import { makeStyles } from '@material-ui/core/styles';
import { COLORS } from 'src/data/ui';

export default makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(1),
      alignItems: 'start',
      padding: theme.spacing(3, 3, 2, 3),
      backgroundColor: 'white',
      border: theme.shape.border,
      borderRadius: theme.shape.borderRadiusLarge,
      boxShadow: '0px 0px 23px -3px rgba(23, 43, 77, 0.21)',
      marginTop: theme.spacing(13) + 'px !important',
    },

    titlesContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(1),
    },

    title: {
      fontWeight: theme.typography.fontWeightSemiBold,
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(16),
      color: COLORS.neutral.blackBlue,
    },

    subtitle: {
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(24),
      color: COLORS.neutral.blackBlue,
    },

    examplesContainer: {
      padding: theme.spacing(1.5, 2),
      background: COLORS.gray.gray90,
      borderRadius: theme.shape.borderRadius,
    },

    examplesTitle: {
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(24),
      color: COLORS.gray.gray30,
    },

    examplesParagraph: {
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(24),
      color: COLORS.gray.gray30,
      paddingBottom: theme.spacing(1),
    },

    button: {
      marginTop: theme.spacing(1),
      marginLeft: 'auto',
      height: 'fit-content',
      fontWeight: theme.typography.fontWeightSemiBold,
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(16),

      '& $buttonLabel': {
        padding: theme.spacing(0.25, 2),
      },
    },

    buttonLabel: {},

    arrow: {
      height: 0,
      width: 0,
      borderTop: '16px solid transparent',
      borderBottom: '16px solid transparent',
      borderRight: '16px solid white',
      position: 'absolute',
      top: theme.spacing(4),
      left: theme.spacing(-2),
    },
  }),
  { name: 'PromptWithUrlHint' }
);
